import React from 'react';
import PropTypes from 'prop-types';
import './ErrorBoundaries.scss';

export default class PageErrorBoundary extends React.Component {
  state = {
    hasError: false,
  };

  componentDidCatch(error, errorInfo) {
    this.setState({ hasError: true });
    console.log(error, errorInfo);
  }

  render() {
    const { children } = this.props;

    if (this.state.hasError) {
      return (
        <div className="mn_pageErrorBoundary">
          <h2>Well, this is awkward</h2>
          <p>Something went wrong with the page you're looking for.
            Please try your request again later.
          </p>
        </div>
      );
    }

    return children;
  }
}

PageErrorBoundary.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
};
